import {Base} from "@/api/Base"

export class LeaveTypeList extends Base {
    path = "leaveType/list"
}